let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jqU8W")).then(() => parcelRequire('ijw8O'));